
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-builder",
      function () {
        return require("private-next-pages/team-builder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-builder"])
      });
    }
  